var map = {
	"./address.svg": "e8fc",
	"./bonuses.svg": "7b40",
	"./clipboard.svg": "4247",
	"./collapse-left.svg": "d4b1",
	"./collapse-right.svg": "72b9",
	"./delete.svg": "0d45",
	"./email.svg": "43be",
	"./icon-area.svg": "c3aa",
	"./icon-arrow-down.svg": "e0c5a",
	"./icon-arrow-up.svg": "47e8",
	"./icon-construction.svg": "3ac9",
	"./icon-door.svg": "f446",
	"./icon-down.svg": "02dd",
	"./icon-edit.svg": "d5ef",
	"./icon-facade.svg": "d9fa",
	"./icon-facebook.svg": "c263",
	"./icon-flat.svg": "168e",
	"./icon-floor.svg": "6c34",
	"./icon-instagram.svg": "6799",
	"./icon-paper-fail.svg": "30e8",
	"./icon-plus.svg": "a3b7",
	"./icon-questions__circle.svg": "e9cb",
	"./icon-right.svg": "414c",
	"./icon-telegram.svg": "3aba",
	"./icon-tick-circle.svg": "9b7a",
	"./icon-up.svg": "0cf9",
	"./icon-warning-circle.svg": "5f16",
	"./icons-globe.svg": "4115",
	"./last-name.svg": "8f0a",
	"./loading-bar.svg": "c8e3",
	"./location.svg": "d2eb",
	"./no-preview-aye.svg": "72a4",
	"./phone-call.svg": "c251",
	"./phone.svg": "c3bb",
	"./preview-aye.svg": "58d3",
	"./qr_instagram.svg": "ab3f",
	"./qr_telegram.svg": "69f0",
	"./qr_web.svg": "eac7",
	"./question.svg": "9872",
	"./refresh.svg": "53fa",
	"./second-name.svg": "aa46",
	"./table-button.svg": "5d73",
	"./tag-close.svg": "b38e",
	"./tail-spin.svg": "2218",
	"./user-account.svg": "354c",
	"./user-avatar.svg": "b7fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";